export const DownArrow = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      className="fill-zinc-300 inline"
    >
      <path d="M 6,10 10,3 2,3 z" strokeLinejoin="round" />
    </svg>
  )
}
